import { AxiosAdapter } from '../../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';

export class Service {
	async create(body) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.MIGRATION_PHAROL}/carousel-product/create-v2`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async updateTag(body) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: `${Enviroment.MIGRATION_PHAROL}/carousel-product/update-tag`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async getProducts(productsId) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FRONT_COMMON}/product/${Enviroment.COUNTRY}/find-by-multiple-ids/${productsId}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
